<template>
    <div>
        <div v-if="sellpoint" style="text-align: left; padding: 1em; height: auto;">
          <div class="menu-links-strip menu-links-strip-2">
            <ul>
              <a class="card-link" @click="setMenuTabViewLink('product','setBusinessCategoryProductDetails',sellpoint,'/account/business/product')"><li>
                Product Details
              </li></a>
              <!-- <a class="card-link" @click="setMenuTabView('product','setBusinessCategoryProductItems',sellpoint,'')"><li>
                Product Types / Variations
              </li></a> -->
              <a class="card-link" @click="setMenuTabViewLink('product','setBusinessCategoryProductItems',sellpoint,'/account/business/product/types')"><li>
                Product Types / Variations
              </li></a>
              <a class="card-link" @click="setMenuTabViewLink('product','setBusinessCategoryProductReviews',sellpoint,'/account/business/product/reviews')"><li>
                Reviews
              </li></a>
              <a class="card-link" @click="setMenuTabViewLink('product','setBusinessCategoryProductOrders',sellpoint,'/account/business/product/orders')"><li>
                Orders
              </li></a>
              <a class="card-link" @click="setMenuTabViewLink('product','setBusinessCategoryProductAddOns',sellpoint,'/account/business/product/addons')"><li>
                Product Addons
              </li></a>
              <a class="card-link" @click="setMenuTabViewLink('product','setBusinessCategoryProductDiscountCoupons',sellpoint,'/account/business/product/discounts')"><li>
                Discounts and Coupons
              </li></a>
              <a class="card-link" @click="setMenuTabViewLink('product','setBusinessCategoryProductShippingInformation',sellpoint,'/account/business/product/shipping')"><li>
                Shipping and Delivery 
              </li></a>
            </ul>
          </div>
          <div class="card card-flat component-tabs">
           
          </div>
        </div>
    </div>
</template>

<style>
 @import url("style.css");
</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        self.product =  value.account.store_sellpoint.store_product;
                    }else{}
                });
           
            },
        },

        components: {},

        created: function(){
            this.setPage();
        }
    }
</script>


// WEBPACK FOOTER //
// ProductSettings.vue?3e6bff6e